module.exports = __webpack_public_path__ + "img/not-found.9dc3c831.png";